<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3 class="footer-title">关于我们</h3>
          <p>智算通是一家现代财税+科技服务企业，以专业、高效、可靠为服务宗旨，关于财税，我们持有国家颁发的《代理记账许可证》，并深耕工商财税领域多年，帮助企业主聚焦核心业务，规避经营风险，实现合规稳健发展。关于科技，从代码安全到系统智能——提供高可靠、可扩展、自主可控的技术解决方案。</p>
        </div>
        <div class="footer-section">
          <h3 class="footer-title">快速链接</h3>
          <ul class="footer-links">
            <li><a href="/">工商财务</a></li>
            <li><a href="/tech">软件服务</a></li>
            <li><a href="/about">关于我们</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3 class="footer-title">联系我们</h3>
          <p>邮箱: hnalis@163.com</p>
          <p>电话: 199 0768 8200</p>
          <p>电话: 186 8967 0787</p>
          <div class="social-icons">
            <a href="#"><i class="fab fa-facebook"></i></a>
            <a href="#"><i class="fab fa-twitter"></i></a>
            <a href="#"><i class="fab fa-linkedin"></i></a>
            <a href="#"><i class="fab fa-instagram"></i></a>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>琼ICP备2025058617号-1 &copy; 2025 智算通科技有限公司</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
.footer {
  background-color: var(--secondary-color);
  color: white;
  padding: 60px 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-section {
  margin-bottom: 20px;
}

.footer-title {
  font-size: 1.3rem;
  margin-bottom: 20px;
  color: white;
}

.footer-links {
  list-style: none;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: #ddd;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: var(--primary-color);
}

.social-icons {
  display: flex;
  gap: 15px;
  margin-top: 15px;
}

.social-icons a {
  color: white;
  font-size: 1.2rem;
  transition: color 0.3s;
}

.social-icons a:hover {
  color: var(--primary-color);
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.9rem;
  color: #aaa;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
  }
  
  .footer-section {
    text-align: center;
  }
  
  .social-icons {
    justify-content: center;
  }
}
</style>